export default __webpack_public_path__ + "static/media/gallery - story - heart (1)_00.455c66bf.jpg";